import { AfterViewInit, Directive, ElementRef, Input, OnDestroy } from '@angular/core';

@Directive({ selector: '[fhNumericInput]' })
export class NumericInputDirective implements AfterViewInit, OnDestroy {
  @Input() allowDecimals = true;

  private readonly FORBIDDEN_KEYS = ['e', 'E', '+', '-'];
  private readonly FORBIDDEN_KEYS_NO_DECIMAL = ['e', 'E', '+', '-', '.'];

  constructor(private readonly el: ElementRef<HTMLElement>) {}

  ngAfterViewInit(): void {
    this.nativeInput?.addEventListener('keydown', this.onKeydown);
  }

  ngOnDestroy(): void {
    this.nativeInput?.removeEventListener('keydown', this.onKeydown);
  }

  private readonly onKeydown = (ev: KeyboardEvent): void => {
    const blocked = this.allowDecimals ? this.FORBIDDEN_KEYS : this.FORBIDDEN_KEYS_NO_DECIMAL;
    const input = this.nativeInput;
    if (blocked.includes(ev.key) || (ev.key === '.' && input?.value.includes('.'))) {
      ev.preventDefault();
    }
  };

  private get nativeInput(): HTMLInputElement | null {
    return this.el.nativeElement.querySelector('input');
  }
}
